import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightBulbSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLightBulbSimple"><Path d="M8.5 17.5V19C8.5 20.933 10.067 22.5 12 22.5C13.933 22.5 15.5 20.933 15.5 19V17.5M8.5 17.5V16.635C6.1211 15.3775 4.5 12.878 4.5 10C4.5 5.85786 7.85786 2.5 12 2.5C16.1421 2.5 19.5 5.85786 19.5 10C19.5 12.878 17.8789 15.3775 15.5 16.635V17.5M8.5 17.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLightBulbSimple;
